
import { i18nText } from '@/locales';

import {Component, Vue} from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import Badge from "@/UI/components/common/Badge.vue";
import { IAccess, IAccessListItem, AccessListItemResponseType, AccessResponseType } from "@/entity/salons/access.types";
import AccessForm from "@/form/salonGeneral/access";
import AccessUpdateForm from "@/form/salonGeneral/accessUpdate";
import {AccessStore} from "@/store/modules/Access";
import AccessUpdate from "@/UI/components/forms/access/AccessUpdate.vue";
import AccessServiceAddForm from "@/UI/components/forms/access/AccessServiceAdd.vue";
import {message} from "ant-design-vue";

@Component({
  components: {Badge, PageTitle, AccessUpdate, AccessServiceAddForm}
})
export default class SalonAccesses extends Vue {

  create_modal_form: boolean = false;
  update_modal_form: boolean = false;

  checkRole: boolean = false;

  form = new AccessForm();
  formUpdate = new AccessUpdateForm();

  showUpdateModal(access : IAccessListItem) : void{
      this.formUpdate = new AccessUpdateForm();
      this.formUpdate.setFormData(access);
      this.update_modal_form = true;
  }

  async createAllow(){
     this.form.salon_id = parseInt(this.$route.params.id);
      if (await this.form.submit(AccessStore.create)) {
        await AccessStore.fetchAll({filter: {salon_id: parseInt(this.$route.params.id)}});
        this.form = new AccessForm();
        this.create_modal_form = false;
      }
  }

  async updateAllow(){
    if (await this.formUpdate.submit(AccessStore.update)) {
        await AccessStore.fetchAll({filter: {salon_id: parseInt(this.$route.params.id)}});
        this.update_modal_form = false;
        this.formUpdate = new AccessUpdateForm();
      }
  }

  async deleteAllow(id : number){
    if(await  AccessStore.delete({id: id})) {
      message.success(i18nText("Данные успешно удалены"));
      await AccessStore.fetchAll({filter: {salon_id: parseInt(this.$route.params.id)}});
    } else {
      message.error(i18nText("Что то пошло не так..."))
    }
  }

  get accessItem() : IAccessListItem | null{
    return AccessStore.accessItem;
  }

  get access() : IAccess | null{
    return AccessStore.access;
  }

  async created(): Promise<void> {
    await AccessStore.fetchAll({filter: {salon_id: parseInt(this.$route.params.id)}});
  }


}
